module.exports = __webpack_public_path__ + "img/img_throw_3@2x_v3.da9949fb.png";